import React from 'react';
import Swiper from '@softmedialab/react-native-web-swiper';
import {View, TouchableOpacity, Platform} from 'react-native';
import {Props} from './model';
import {images} from '../../../assets/icons';
import {useStyles} from '../../hooks/styles';
import {useTheme} from '../../theme';

const buttonPadding = 10;

export const ViewMobile: React.FC<Props> = ({children, slidesPerView, testID}) => {
  const theme = useTheme();
  const [index, setIndex] = React.useState(0);
  const swiperRef = React.useRef<any>(null);

  const styles = useStyles(() => ({
    container: {},
    dot: {
      width: 15,
      height: 3,
      marginTop: 3,
      marginLeft: 5,
      marginRight: 5,
    },
    dotsWrapper: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      flexShrink: 1,
      justifyContent: 'center',
    },
    arrow: {
      width: 20,
      height: 20,
    },
    newsCardContainer: {
      flexGrow: 0.85,
      paddingTop: 24,
    },
    button: {
      padding: buttonPadding,
    },
    buttonLeft: {
      right: buttonPadding,
    },
    buttonRight: {
      left: buttonPadding,
    },
    swipeArea: {
      position: 'relative',
    },
    controls: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: 16,
    },
    swiperContainer: {
      flexGrow: Platform.OS === 'web' ? 0 : undefined,
    },
  }));

  const goNext = () => {
    if (swiperRef.current) {
      swiperRef.current.goToNext();
    }
  };

  const goPrev = () => {
    if (swiperRef.current) {
      swiperRef.current.goToPrev();
    }
  };
  const Controls: any = () => null;

  const childrenArr = [children].flat();

  /* Array of news should be filled first, slides won't be displayed otherwise */
  if (!childrenArr.length) {
    return null;
  }

  return (
    <View testID={testID} style={styles.container}>
      <View testID='swiper-mobile-id' {...{dataSet: {class: 'swiper-container'}}}>
        {/* @ts-expect-error Swiper types don't include children prop */}
        <Swiper
          containerStyle={styles.swiperContainer}
          ref={swiperRef}
          Controls={Controls}
          onIndexChanged={setIndex}
          slidesPerView={slidesPerView}
          loopAnimation='extension'
          swipeAreaStyle={styles.swipeArea}
          minDistanceToCapture={30}
          alternatePan
          autoHeight
          loop>
          {childrenArr.map((child, indx) => (
            <View style={styles.newsCardContainer} key={indx}>
              {child}
            </View>
          ))}
        </Swiper>
      </View>

      <View style={styles.controls}>
        <TouchableOpacity testID='swiper-mobile-left-id' onPress={goPrev} style={[styles.button, styles.buttonLeft]}>
          <images.Left color={theme.color.primaryColor} style={styles.arrow} />
        </TouchableOpacity>
        <View style={styles.dotsWrapper}>
          {childrenArr.map((newsItem, itemIndex) => (
            <View
              style={[
                styles.dot,
                {backgroundColor: itemIndex === index ? theme.color.primaryColor : theme.color.iconGrayColor},
              ]}
              key={itemIndex}
            />
          ))}
        </View>
        <TouchableOpacity testID='swiper-mobile-right-id' onPress={goNext} style={[styles.button, styles.buttonRight]}>
          <images.Right color={theme.color.primaryColor} style={styles.arrow} />
        </TouchableOpacity>
      </View>
    </View>
  );
};
